import React from 'react';
import './InputField.css';

function InputField({ placeholder, maxLength, ...props }) {
  return (
    <div className="input-field">
      <input {...props} maxLength={maxLength} placeholder={placeholder} />
    </div>
  );
}

export default InputField;